import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_conduct_regular_emergency_drills_for_all_wrkrs_and'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_conduct_regular_emergency_drills_for_all_wrkrs_and',
  name: 'Does the facility conduct regular emergency drills for all workers and are they in line with legal requirements?',
  description:
    'All workers (workers in all shifts, on all floors, and in all buildings associated with the facility) must participate in evacuation drills. Workers should know how to react in case of emergency.  Answer No if any workers do not participate in regular evacuation drills, or they do not know how to react in case of emergency.\r\r\n\r\r\nIn the absence of legal requirements, it is recommended that drills be held every six months (if legal requirements address the frequency of drills, apply the legal requirements which may be different from the six month recommendation). \r\r\n\r\r\nApplicable legal requirements may contain additional requirements that must be reviewed to ensure there is no legal non-compliance.\r\r\n\r\r\nIf the facility is not following applicable legal requirements, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-23',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14920,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
